import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
import SmallFont from "Root/profile/components/common/SmallFont";
import { useScreenWidth } from "Root/quiz/hooks/useScrollHook";
import Muscle from "./images/icons-activity-build-muscle.svg";
import Mental from "./images/icons-goals-health-brain.svg";
import Joint from "./images/icons-goals-health-joint.svg";
import Lifestyle from "./images/Lifestyle1-1440-min.png";
import styles from "./styles.module.scss";
import { useInView } from "react-intersection-observer";
const icons = [
    {
        text: "Supports Mind + Body Connection",
        icon: Joint,
        subtext: "Fueled by powerful adaptogens like Lion’s Mane, L-Theanine, and Ginseng to enhance your mental strength and focus",
    },
    {
        text: "Supports Physical + Cognitive Health",
        icon: Mental,
        subtext: "Prebiotic Fibers and a powerful blend of greens that nurture your daily health and immunity. ",
    },
    {
        text: "Helps You Move Smarter + Feel Stronger",
        icon: Muscle,
        subtext: "Supported by phytonutrients from whole food ingredients including Spirulina, Wheatgrass and Kale",
    },
];
const WhyGreens = () => {
    const isMobile = useScreenWidth() < 968;
    const { ref, inView } = useInView();
    return (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.content, children: [_jsx(Eyebrow, { children: "Why Greens" }), _jsxs(H2Font, { children: ["Delicious + Powerful ", _jsx("br", {}), " ", _jsx("b", { children: "Daily Nutrition" }), " For a Powerful"] }), _jsx(H2Font, { style: { background: "#ECFF7A" }, fontWeight: 500, children: _jsx("span", { ref: ref, className: [
                                styles.in_view,
                                inView ? styles.in_view_scrolled : "",
                            ].join(" "), children: "Mind + Body Connection" }) }), _jsx("div", { className: styles.icons, children: icons.map((icon, index) => (_jsxs("div", { className: styles.icon, children: [_jsx("img", { src: icon.icon, alt: icon.text }), _jsxs("div", { className: styles.text_wrapper, children: [_jsx(RegFont, { fontWeight: 400, children: icon.text }), _jsx(SmallFont, { color: "1E534D", children: icon.subtext })] })] }, index))) })] }), _jsx("div", { className: styles.img, children: _jsx("img", { src: Lifestyle, alt: "lifestyle" }) })] }));
};
export default WhyGreens;
